import { render, staticRenderFns } from "./TablaErrores.vue?vue&type=template&id=79e4561b&scoped=true"
import script from "./TablaErrores.vue?vue&type=script&lang=js"
export * from "./TablaErrores.vue?vue&type=script&lang=js"
import style0 from "./TablaErrores.vue?vue&type=style&index=0&id=79e4561b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4561b",
  null
  
)

export default component.exports